<template>

<div id="slide04" class="section section-white">

  <Subtitle :text="$t('home.slide04.title')"/>

  <carousel
    :per-page="1"
    :autoplay="true"
    :loop="true"
    :autoplay-hover-pause="false"
    :autoplay-timeout=5000
    pagination-active-color="#171c33"
    pagination-color="#bac6e6">

    <slide>
      <S04Section01/>
    </slide>

    <slide>
      <S04Section02/>
    </slide>

    <slide>
      <S04Section03/>
    </slide>

    <slide>
      <S04Section04/>
    </slide>

    <slide>
      <S04Section05/>
    </slide>

  </carousel>

</div>

</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
import Subtitle from '../general/texts/Subtitle.vue'
import S04Section01 from './sections04/S04Section01.vue'
import S04Section02 from './sections04/S04Section02.vue'
import S04Section03 from './sections04/S04Section03.vue'
import S04Section04 from './sections04/S04Section04.vue'
import S04Section05 from './sections04/S04Section05.vue'

export default {
  name: 'Slide04',
  components: {
    Carousel,
    Slide,
    Subtitle,
    S04Section01,
    S04Section02,
    S04Section03,
    S04Section04,
    S04Section05
  }
}
</script>

<style lang="scss" scoped>
::v-deep .section-block {
  .slide04-text-block {
    width: 100%;

    .one-third-block-2 {
      text-align: center;
      vertical-align: top;

      img {
        width: 100%;
      }
    }
  }
}

@media (min-width: 1500px), (min-device-width: 1500px) {
  ::v-deep .section-block {
    .slide04-text-block {
      .one-third-block-2 {
        img {
          width: 50%;
        }
      }
    }
  }
}

@media (max-width: 900px), (max-device-width: 900px) {
  ::v-deep .section-block {
    height: 100%;

    .number {
      margin-bottom: 20px;
    }

    .slide04-text-block {
      height: 85%;
      position: relative;

      .one-third-block-2 {
        width: 30%;
      }
    }
  }
}

@media (max-width: 750px), (max-device-width: 750px) {
  ::v-deep .section-block {
    .slide04-text-block {
      height: 90%;

      .one-third-block-2 {
        width: 40%;
      }
    }
  }
}

@media (max-width: 650px), (max-device-width: 650px) {
  ::v-deep .section-block {
    .slide04-text-block {
      .one-third-block-2 {
        width: 50%;
      }
    }
  }
}

@media (max-width: 550px), (max-device-width: 550px) {
  ::v-deep .section-block {
    .slide04-text-block {
      .one-third-block-2 {
        width: 60%;
      }
    }
  }
}

@media (max-width: 450px), (max-device-width: 450px) {
  ::v-deep .section-block {
    .slide04-text-block {
      .one-third-block-2 {
        width: 75%;
      }
    }
  }
}

@media (max-width: 400px), (max-device-width: 400px) {
  ::v-deep .section-block {
    .slide04-text-block {
      .one-third-block-2 {
        width: 100%;
      }
    }
  }
}
</style>
